const EMAILS_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
const scraper: (text: string) => string[] = (text) => {
	const matches = text.match(EMAILS_REGEX);

	if (!matches) {
		return [];
	}

	const uniqueEmails = [...new Set(matches)];
	return uniqueEmails;
};
export const useEmailsScraper = () => ({ scraper });
